const GET_STAFF_LIST = 'GET_STAFF_LIST'
const GET_STAFF_LIST_SUCCESS = 'GET_STAFF_LIST_SUCCESS'


const StaffType = {
  GET_STAFF_LIST,
  GET_STAFF_LIST_SUCCESS

}

export default StaffType
